import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/**
 * RecruitInvite — visited via /r/{code}. Persists the code to sessionStorage
 * (so it survives across the marketing pages on the way to signup) and
 * redirects to /register?ref=CODE for the actual attribution flow.
 *
 * Why a tiny dedicated route?
 *   • Pretty, share-friendly URLs ("bidorah.com/r/AVA42K").
 *   • Lets us drop one cookie/storage stamp regardless of how many landing
 *     pages the visitor wanders through before hitting Register.
 *   • Keeps the marketing surface clean — no ?ref query bloat on every page.
 */
export default function RecruitInvite() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) {
      const clean = code.toUpperCase().slice(0, 6);
      try {
        sessionStorage.setItem("bidorah_recruit_code", clean);
      } catch (_) {
        /* ignore — non-critical */
      }
      navigate(`/register?ref=${clean}`, { replace: true });
    } else {
      navigate("/register", { replace: true });
    }
  }, [code, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-zinc-950 text-white">
      <div className="text-center">
        <div className="text-5xl font-display font-black tracking-tighter">Bidorah</div>
        <div className="mt-2 text-sm text-zinc-400">Forwarding your invite…</div>
      </div>
    </div>
  );
}
